import { Card, Col, Row, Tooltip } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import React, { } from 'react';
import { createUseStyles } from 'react-jss';
import { QueryDetail, QueryOrder, QueryParam } from 'fennec-ui';
import Icofont from 'react-icofont';
import { Action } from 'fennec-ui'
import { CollectionServer } from 'fennec-ui';
import ZakazAdminPreview from '../../forms/ZakazAdminPreview';
import PageLayout from '../../components/PageLayout';
import { useLocaladminContext } from '../../../common/Context';
dayjs.locale('ru');
var _ = require('lodash');

const useStyles = createUseStyles({
	block: {
		'& .buttons': {
			marginBottom: "10px"
		},
	},
	ticket: {
		padding: "5px 10px",
		display: "flex",
		cursor: "pointer",
		'&:hover': {
			backgroundColor: "#f9f9f9"
		}
	},
	ticketHeader: {
	},
	ticketName: {

	},
	collapsePanel: {
		'& .ant-collapse-content > .ant-collapse-content-box': {
			padding: "6px"
		},
		'&.ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box': {
			paddingTop: "0px",
			paddingBottom: "0px"
		}
	}
})

export default function LocaladminEventsOrders(props) {
	const classes = useStyles();
	const { auth } = props;
	const local = useLocaladminContext();

	const orderStatus = (item) => {
		let paymentStateID = 0
		if (item.ekvairingZakaz && item.ekvairingZakaz[0]) {
			paymentStateID = item.ekvairingZakaz[0].paymentStateID
		}

		if (item.statusID == 4) { // Завершен
			return (
				<Tooltip title={item.status.opisanie}>
					<Icofont icon="check-circled" />
				</Tooltip>
			)
		}

		if (item.statusID == 5) { // Ошибка оплаты
			return (
				<Tooltip title={item.status.opisanie}>
					<Icofont icon="close-circled" />
				</Tooltip>
			)
		}

		if (item.statusID == 2) { // Оплата возвращена
			return (
				<Tooltip title={item.status.opisanie}>
					<Icofont icon="close-circled" />
				</Tooltip>
			)
		} else if (paymentStateID) { //Если есть объект эквайринга
			if (paymentStateID == 2) { // Новый
				return (
					<Tooltip title={item.ekvairingZakaz[0].paymentState.opisanie}>
						<Icofont icon="clock-time" />
					</Tooltip>
				)
			}
			if (paymentStateID == 3) { // Оплачен
				return (
					<Tooltip title={item.ekvairingZakaz[0].paymentState.opisanie}>
						<Icofont icon="pay" />
					</Tooltip>
				)
			}
			if (paymentStateID == 4) { // Отменен
				return (
					<Tooltip title={"Отменен"}>
						<Icofont icon="close-circled" />
					</Tooltip>
				)
			}
		} else {
			if (item.statusID == 1) { // Новый
				return (
					<Tooltip title={item.status.opisanie}>
						<Icofont icon="clock-time" />
					</Tooltip>
				)
			}
			if (item.statusID == 3) { // Оплачен
				return (
					<Tooltip title={item.status.opisanie}>
						<Icofont icon="pay" />
					</Tooltip>
				)
			}
		}
	};

	const orderStatusSumma = (item) => {
		let paymentStateID = 0
		if (item.ekvairingZakaz && item.ekvairingZakaz[0]) {
			paymentStateID = item.ekvairingZakaz[0].paymentStateID
		}

		if (item.statusID == 2) { // Оплата возвращена
			return (
				<div>
					<div style={{ alignSelf: "flex-start", color: "#7c7c7c", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
						Оплата возвращена:
					</div>
					<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
						<div style={{ color: "#7c7c7c" }}>{item.obshchayaSumma.toLocaleString()} руб.</div>
					</div>
				</div>)
		} else if (item.statusID == 3 || item.statusID == 4) { // Оплачен
			return (
				<div>
					<div style={{ alignSelf: "flex-start", color: "rgb(63, 134, 0)", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
						Оплачено:
					</div>
					<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
						<div style={{ color: "rgb(63, 134, 0)" }}>{item.obshchayaSumma.toLocaleString()} руб.</div>
					</div>
				</div>)
		} else if (item.statusID == 5) { // Ошибка оплаты
			return (
				<div>
					<div style={{ alignSelf: "flex-start", color: "#ff4d4f", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
						Ошибка оплаты:
					</div>
					<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
						<div style={{ color: "#ff4d4f" }}>{item.obshchayaSumma.toLocaleString()} руб.</div>
					</div>
				</div>)
		} else if (paymentStateID) { //Если есть объект эквайринга
			if (paymentStateID == 2) { // Новый
				return (
					<div>
						<div style={{ alignSelf: "flex-start", color: "#eb8100", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
							К оплате:
						</div>
						<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
							<div style={{ color: "#eb8100" }}>{item.obshchayaSumma.toLocaleString()} руб.</div>
						</div>
					</div>)
			}
			if (paymentStateID == 3) { // В процессе оплаты
				return (
					<div>
						<div style={{ alignSelf: "flex-start", color: "#0095ff", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
							Оплата:
						</div>
						<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
							<div style={{ color: "#0095ff" }}>{item.obshchayaSumma.toLocaleString()} руб.</div>
						</div>
					</div>)
			}
			if (paymentStateID == 4) { // Отменен
				return (
					<div>
						<div style={{ alignSelf: "flex-start", color: "#ff4d4f", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
							Отменен:
						</div>
						<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
							<div style={{ color: "#ff4d4f" }}>{item.obshchayaSumma.toLocaleString()} руб.</div>
						</div>
					</div>)
			}
		} else {
			if (item.statusID == 1) { // Новый
				return (
					<div>
						<div style={{ alignSelf: "flex-start", color: "#eb8100", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
							К оплате:
						</div>
						<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
							<div style={{ color: "#eb8100" }}>{item.obshchayaSumma.toLocaleString()} руб.</div>
						</div>
					</div>)
			}
		}
	};
	const filters = () => [
		{
			name: "obshchayaSumma",
			filterType: "range",

			func: ["min", "max"],
			// min: -25,
			// max: 10000,
			// step: 7,
			// step: 1000,

			sort: true,
			filter: true,
		},
		{
			name: "dataZakaza",
			type: "date",
			filterType: "range",
			sort: true,
			filter: true,
			sorted: "DESC"
		},
		{
			name: "nomerZakaza",
			sort: true,
			filter: true,
		},
		{
			name: "ekvairingZakaz.nomer",
			filter: true,
		},
		{
			name: "status",
			filterType: "group",
			// source: "/api/query/zakazstatus",
			display: (o) => o.nazvanie,
			sort: true,
			filter: true,
		},
		{
			name: "ekvairingZakaz.paymentState",
			filterType: "group",
			// source: "/api/query/zakazstatus",
			display: (o) => o.opisanie,
			filter: true,
		},
		{
			name: "meropriyatie.mestoProvedeniya",
			filterType: "group",
			queryFilter: [
				QueryDetail("model"),
				QueryOrder("name", "ASC"),
				// QueryParam("w-region","77")
			],
			// source: "/api/query/city",
			display: (o) => o.name,
			sort: true,
			filter: true,
		}
	];
	const title = () => (<div style={{
		color: "rgba(0, 0, 0, 0.85)",
		fontWeight: "500",
		fontSize: "16px"
	}}>
		Заказы
	</div>);
	const render = (item, idx, { setCollection, setCollectionItem, update }) =>
	(<div key={idx} style={{ width: "100%" }} >
		<Action
			auth={auth}
			action={() => {
			}}
			object={item} // заказ
			collectionActions={{ setCollection, setCollectionItem, update }}
			modal={{
				width: "750px",
				title: "Заказ №" + item.nomerZakaza + " от " + dayjs(item.dataZakaza).format("DD.MM.YYYY HH:mm:ss")
			}}

			readonly={true}
			mode={"func"}
			noAntForm={true}
			form={ZakazAdminPreview}
			trigger={(click) => (
				<div className={classes.ticket} onClick={click}>
					<div style={{ flex: "auto" }}>
						<div style={{ fontWeight: "500" }}>
							<div style={{ display: "flex", justifyContent: "space-between" }}>
								<div>
									{item.status && <span style={{ paddingRight: "5px" }}>
										{orderStatus(item)}
									</span>}
									№{item.nomerZakaza} от {dayjs(item.dataZakaza).format("DD.MM.YYYY HH:mm:ss")}
								</div>
								<div style={{ flex: "auto", margin: "10px 10px", height: "1px", borderColor: "#f0f0f0", borderWidth: "1px", borderStyle: "dotted" }}></div>
							</div>
						</div>
						{(item.polzovatel) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
							<div>Покупатель: {item.polzovatel.lastname} {item.polzovatel.firstname}</div>
							<div style={{fontSize: "12px", fontStyle: "italic", color: "rgba(0,0,0,0.45)"}}>{item.polzovatel.phone}, {item.polzovatel.email}</div>
						</div>}
						{(item.ekvairingZakaz && item.ekvairingZakaz[0]) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
							Оплата заказа №{item.ekvairingZakaz[0].nomer}
						</div>}
						{item.meropriyatie && <div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.45)" }}>
							{item.meropriyatie.nazvanieMeropriyatiya} - {dayjs(item.meropriyatie.nachaloSorevnovaniya).format("DD.MM.YYYY")},  {_.get(item, "meropriyatie.mestoProvedeniya.name")}
						</div>}
					</div>
					{orderStatusSumma(item)}
				</div>
			)}
		/>
	</div>)
	const FilterFromContextFilter = React.useCallback(() => {
		if (local) {
			return [
				QueryParam("w-meropriyatie.organizatorRegionalnoeOtdelenie.ID", local.ID)
			]
		}
		return []
	}, [local]);
	return (
		<PageLayout>
			<div style={{ backgroundColor: "white", borderRadius: "4px" }}>
				<div style={{ padding: "10px" }}>
					{local && <CollectionServer
						auth={auth}
						name={"Zakaz"}
						source={"/api/zakaz/getallbyorgreg"}

						contextFilters={FilterFromContextFilter}
						filters={filters}

						size={"small"}
						mode={"list"}
						titleFunc={title}
						render={render}

					// collectionActions={emptyArray}
					// modelActions={emptyArray}
					/>}
				</div>
			</div>
		</PageLayout>
	);
}
